import { InfoOutlined, UploadFile } from "@mui/icons-material";
import {
    Alert,
    AlertTitle,
    Box,
    Button,
    Card,
    CardContent,
    CircularProgress,
    Collapse,
    IconButton,
    LinearProgress,
    TextField,
    Typography,
} from "@mui/material";
import { useState } from "react";
import * as XLSX from "xlsx";
import { ReadingService } from "../../../Services/ReadingService";

const readExcelFileAndCreateNegativeReadings = async (
    bin: string | ArrayBuffer | null | undefined,
    payload?: Record<string, any>
): Promise<any[]> => {
    console.log("in readExcelFileAndCreateCollections");
    const wb = XLSX.read(bin, { type: "binary" });

    const sheets = wb.Sheets;

    let negativeReadingFailures: any[] = [],
        negativeReadingSuccess: any[] = [];

    for (const sheet of Object.values(sheets)) {
        // Convert sheet to JSON and format dates
        const json = XLSX.utils.sheet_to_json(sheet, {
            raw: false, // Ensures dates are parsed as strings
            dateNF: "yyyy-mm-dd", // Format for dates
        });

        const [data, err] = await ReadingService.createReadingCollections(
            json,
            payload
        );

        console.log("data", data, "error", err);

        if (data) {
            negativeReadingSuccess = data.successes;
            negativeReadingFailures = data.failures;
        } else {
            negativeReadingSuccess = err.successes;
            negativeReadingFailures = err.failures;
        }
    }

    return [negativeReadingSuccess, negativeReadingFailures];
};

export const CreateReadingWithExcel = () => {
    // const classes = useStyles();
    const [loading, setLoading] = useState<"loading" | "initial" | "finished">(
        "initial"
    );
    const [fname, setFname] = useState("");

    const [successes, setSucesses] = useState<any>([]);
    const [failures, setFailures] = useState<any>([]);
    const [showResponseDetails, setShowResponseDetails] = useState(false);
    const [file, setFile] = useState<File | null>(null);
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    const formattedToday = `${yyyy}-${mm}-${dd}`;

    const [readingDate, setReadingDate] = useState(formattedToday);
    const [issueDate, setIssueDate] = useState(formattedToday);
    const [dueDate, setDueDate] = useState(formattedToday);
    const [month, setMonth] = useState(String(today.getMonth() + 1));
    const [year, setYear] = useState(String(yyyy));

    const handleFileUpload = async () => {
        // const file = ev.target.files && ev.target.files[0];
        file && setFname(file.name);
        const reader = new FileReader();

        if (file) {
            setLoading(() => "loading");

            reader.onload = async (evt) => {
                const binary = evt.target?.result;

                const [_successes, _failures] =
                    await readExcelFileAndCreateNegativeReadings(binary, {
                        readingDate,
                        issueDate,
                        dueDate,
                        month: Number(month),
                        year: Number(year),
                    });

                console.log("_successes", _successes, "_failures", _failures);

                setFailures(_failures);
                setSucesses(_successes);

                setLoading("finished");
            };

            reader.readAsBinaryString(file);
        }

        // setLoading("finished");
    };

    return (
        <Card>
            <CardContent>
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Typography variant="h5" fontWeight="bold">
                        Create Negative Reading With Excel
                    </Typography>

                    <Box display={"flex"} gap={1}>
                        <Button
                            variant="contained"
                            color="secondary"
                            disabled={loading === "loading"}
                            startIcon={
                                loading === "loading" ? (
                                    <CircularProgress size={20} />
                                ) : (
                                    <UploadFile />
                                )
                            }
                            onClick={() => {
                                file && handleFileUpload();
                            }}
                        >
                            Upload File
                        </Button>
                    </Box>
                </Box>

                <div>
                    <div>
                        {/* <Button
                            variant="contained"
                            component="label"
                            sx={{ mt: "1rem" }}
                            color="secondary"
                        >
                             <input
                                // onChange={handleFileUpload}
                                // hidden
                                type="file"
                                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                             Choose File
                        </Button>  
                         <Typography
                            variant="caption"
                            style={{ fontWeight: "bold" }}
                            sx={{ display: "flex", alignItems: "center" }}
                            mt={"10px"}
                        >
                            {fname}
                        </Typography> */}

                        <input
                            // onChange={handleFileUpload}
                            onChange={(e) => {
                                setFile(
                                    e.target.files?.length
                                        ? e.target.files[0]
                                        : null
                                );
                            }}
                            // hidden
                            type="file"
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        />
                    </div>

                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns:
                                "repeat(auto-fit, minmax(180px, 1fr))",
                            gap: 2,
                            mt: 2,
                            mb: 2,
                        }}
                    >
                        <TextField
                            label="Reading Date"
                            type="date"
                            value={readingDate}
                            onChange={(e) => setReadingDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                        <TextField
                            label="Issue Date"
                            type="date"
                            value={issueDate}
                            onChange={(e) => setIssueDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                        <TextField
                            label="Due Date"
                            type="date"
                            value={dueDate}
                            onChange={(e) => setDueDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                        <TextField
                            label="Month"
                            select
                            SelectProps={{ native: true }}
                            value={month}
                            onChange={(e) => setMonth(e.target.value)}
                        >
                            {Array.from({ length: 12 }, (_, index) => (
                                <option key={index + 1} value={index + 1}>
                                    {new Date(0, index).toLocaleString("en", {
                                        month: "long",
                                    })}
                                </option>
                            ))}
                        </TextField>
                        <TextField
                            label="Year"
                            select
                            SelectProps={{ native: true }}
                            value={year}
                            onChange={(e) => setYear(e.target.value)}
                        >
                            {Array.from({ length: 20 }, (_, index) => {
                                const y = new Date().getFullYear() - 10 + index;
                                return (
                                    <option key={y} value={y}>
                                        {y}
                                    </option>
                                );
                            })}
                        </TextField>
                    </Box>

                    <Typography variant="body1" gutterBottom mt={"10px"}>
                        Ensure the file format is <strong>.xlsx</strong>. The
                        column names must be:
                        <em>Meter No</em> and <em>Units</em>.
                        <br />
                        <br />
                        Note: <strong>Units</strong> is your current units.
                        <br />
                    </Typography>

                    {loading === "loading" && <LinearProgress />}

                    <section hidden={loading !== "finished"}>
                        <Alert
                            severity="info"
                            action={
                                <IconButton
                                    onClick={() => {
                                        setShowResponseDetails(
                                            !showResponseDetails
                                        );
                                    }}
                                >
                                    <InfoOutlined fontSize="small" />
                                </IconButton>
                            }
                        >
                            <AlertTitle>
                                {`${successes.length} successes out of ${
                                    (successes.length ?? 0) +
                                    (failures.length ?? 0)
                                } `}
                            </AlertTitle>

                            <Collapse in={showResponseDetails}>
                                {successes?.map(
                                    (
                                        suc: {
                                            message: string;
                                            meterNo: number | string;
                                        },
                                        index: number
                                    ) => (
                                        <Box key={index}>
                                            {`Meter No - (${suc.meterNo}) - ${suc.message}`}
                                        </Box>
                                    )
                                )}

                                {failures.map(
                                    (
                                        err: {
                                            message: string;
                                            meterNo: number | string;
                                        },
                                        index: number
                                    ) => (
                                        <Box key={index}>
                                            {`Meter No - (${err.meterNo}) - ${err.message}`}
                                        </Box>
                                    )
                                )}
                            </Collapse>
                        </Alert>
                    </section>
                </div>
            </CardContent>
        </Card>
    );
};
export default CreateReadingWithExcel;
